import React from "react";

// Utils
import useIsDark from '../../../../utils/hooks/darkMode'

const CustomEdge = ({ id, sourceX, sourceY, targetX, targetY, style, markerEnd }) => {
  const isDark = useIsDark();

  // Fixed horizontal offset for the step
  const offset = 60;
  const r = 24; // corner radius

  // Determine direction (down or up)
  const verticalDir = targetY > sourceY ? 1 : -1;

  // The x where the vertical segment starts
  const stepX = sourceX + offset;

  // The y where the curve ends (aligned with targetY)
  const stepY = targetY;

  // If the target is to the left of the source, just draw a straight line
  if (targetX < sourceX) {
    return (
      <path
        id={id}
        style={{
          stroke: '#b3dbff',
          strokeWidth: 4,
          fill: 'none',
          strokeLinecap: 'round',
          ...style,
        }}
        className="react-flow__edge-path"
        d={`M ${sourceX} ${sourceY} L ${targetX} ${targetY}`}
        markerEnd={markerEnd}
      />
    );
  }

  // If the y difference is small, draw a straight horizontal line
  if (Math.abs(targetY - sourceY) < 40) {
    return (
      <path
        id={id}
        style={{
          stroke: isDark ? colors.$zeus-900 : '#008CFF',
          strokeWidth: 4,
          fill: 'none',
          strokeLinecap: 'round',
          ...style,
        }}
        className="react-flow__edge-path"
        d={`M ${sourceX} ${sourceY} L ${targetX} ${targetY}`}
        markerEnd={markerEnd}
      />
    );
  }

  // Path: horizontal, curve, vertical, (optional horizontal to target)
  let path = `M ${sourceX} ${sourceY} `;
  path += `L ${stepX - r} ${sourceY} `; // horizontal to before the curve
  path += `Q ${stepX} ${sourceY} ${stepX} ${sourceY + r * verticalDir} `; // curve
  path += `L ${stepX} ${stepY - r * verticalDir} `; // vertical to before target
  path += `Q ${stepX} ${stepY} ${stepX + r} ${stepY} `; // curve to horizontal
  path += `L ${targetX} ${stepY}`; // horizontal to target

  return (
    <path
      id={id}
      style={{
        stroke: isDark ? colors.$zeus-900 : '#008CFF', // light blue
        strokeWidth: 4,
        fill: 'none',
        strokeLinecap: 'round',
        ...style,
      }}
      className="react-flow__edge-path"
      d={path}
      markerEnd={markerEnd}
    />
  );
}

export default CustomEdge;
